import { FastApiAxiosInstance } from "common/service/axiosInstances";

export const backendUser = {
    getUserImToken: async () => {
        const res = await FastApiAxiosInstance.get(`/api/v1/backend/im/getUserToken`);
        return res;
    },
    createBidGroupChat: async (data: { parentTaskId: number | string; targetBidderId: number | string }) => {
        return FastApiAxiosInstance.post(`/api/v1/backend/im/createBidGroupChat`, { ...data });
    }
}